import styled from 'styled-components';

interface FormInputProps {
    width?: string;
}



export const FormInput = styled.input<FormInputProps>`
    width: ${({ width }) => width || '400px'};
    padding: 6px 8px;
`;

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 5px;
    margin-bottom: 15px;

    button {
        display: flex;
        align-items: center;
        justify-content: center;

        gap: 8px;

        padding: 8px 12px;

        cursor: pointer;

        svg {
            font-size: 16px;
            flex-shrink: 0;
        }
    }
`;

export const TotalRegistros = styled.span`
    margin-left: auto;
    margin-right: 10px;

    font-weight: bold;
`;

export const FormContainer = styled.div`
    border: 1px solid #ccc;
    padding: 5px;
    margin-bottom: 20px;
`;

export const FormRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
`;

export const FormLabel = styled.label`
    width: 120px;
    min-width: 120px;
    text-align: right;
    padding-right: 10px;
    font-weight: bold;
`;

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const TableContainer = styled.div`
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    th,
    td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
    }

    th {
        background: #f5f5f5;
    }
`;

interface TableRowProps {
    selected: boolean;
}

export const TableRow = styled.tr<TableRowProps>`
    cursor: pointer;

    background-color: ${({ selected }) =>
        selected ? '#2d5a88' : 'transparent'};

    color: ${({ selected }) =>
        selected ? '#fff' : 'inherit'};

    &:hover {
        background-color: ${({ selected }) =>
            selected ? '#2d5a88' : '#f0f0f0'};
    }
`;

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: bold;

    margin-top: 15px;

    button {
        display: flex;
        align-items: center;
        justify-content: center;

        gap: 6px;

        padding: 6px 10px;

        cursor: pointer;

        svg {
            font-size: 14px;
            flex-shrink: 0;
        }
    }
`;

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    margin-left: 5px;
    margin-bottom: 10px;

    label {
        min-width: 120px;
        font-weight: bold;
    }

    input {
        width: 400px;
        padding: 6px;
    }
`;

export const Divider = styled.hr`
    border: 0;
    border-top: 2px solid #bdbdbd;
    margin: 15px 0;
`;


